module.exports = __webpack_public_path__ + "img/ic_qrcode_line.060f56c.webp";